import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer"; // Ensure Footer is imported
import Products from "./Products";
import Copyright from "./components/Copyright";

import "./styles/main.scss";
// Import Firebase Analytics
// import { logAnalyticsEvent } from "./config/firebase";
import Blogs from "./components/Blogs";
import Blog from "./components/Blog";
import { Helmet } from "react-helmet";
import video from "./assets/images/video.webm";
import mobilevideo from "./assets/images/mobile-video.webm";


function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <MainLayout isMobile={isMobile} setIsMobile={setIsMobile} />
    </Router>
  );
}

function MainLayout({ isMobile }) {
  const location = useLocation();


  return (
    <>
      {/* Hide Header on /products and /blogs pages */}
      {location.pathname !== "/products"  && <Header />}

      <Routes>
        <Route
          path="/"
          element={
            <div id="home-container">
              <Home isMobile={isMobile} />
              <About />
              <Services />
              <Contact />
              {isMobile && <Footer />}
              <Copyright />
            </div>
          }
        />
        <Route path="/products" element={<Products />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<Blog />} />
        {/* <Route path="/analytics-example" element={<AnalyticsExample />} /> */}
      </Routes>
    </>
  );
}

function Home({ isMobile }) {
  return (
    <main className="main-content">
      <Helmet>
        <title>Home - Mevedir</title>
        <meta name="description" content="Welcome to Mevedir, preserving the purity of the Himalayas organically." />
      </Helmet>
      <section className="section1" id="section1">
        {isMobile ? (
          <video autoPlay muted loop className="main-video">
            <source src={mobilevideo} type="video/webm" />
          </video>
        ) : (
          <video autoPlay muted loop className="main-video">
            <source src={video} type="video/webm" />
          </video>
        )}
      </section>
    </main>
  );
}

export default App;
